/**
 * @author emil.ohman@svenskaspel.se (Emil Öhman)
 */
'use strict';

const DEVICE_SIZES = ['xs', 'sm', 'am', 'md', 'lg', 'xl'];

export default DEVICE_SIZES;
